import Vue from 'vue'
export function array2json(array, json) {
    array.forEach(element => {
        Vue.set(json, element.key, element.value)
    });
    return json
}

export function json2array(array, json) {
    array.forEach(element => {
        element.value = json[element.key]
    });
    return array
}

/**
 * 对象数组去重
 * @param {*} array  对象数组
 * @param {*} object  要添加的对象
 */
export function deWeight(array, object) {
    let data = array
    data.push(JSON.parse(JSON.stringify(object)))
    let set = new Set(data.map(JSON.stringify))
    array = Array.from(set).map(JSON.parse)
    return array
}

/**
 * 判断当前字符串是否是数字
 * @param {*} str 要判断的字符串
 * 返回true 为数字型,包含小数
 * 返回false 为字符串型
 */
export function judgeStringIsNumber(str) {
    return !isNaN(str)
}